// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__1h4cK","no-padding":"style_no-padding__2OCe3","centered-content":"style_centered-content__2Pu6W"};